import { LOWEST_PITCH } from '../../gregorio-chant/constants';
import { GregorioLiquescentia } from '../../gregorio-chant/enums/GregorioLiquescentia';
import { GregorioShape } from '../../gregorio-chant/enums/GregorioShape';
import { GregorioGlyph } from '../../gregorio-chant/structures/GregorioGlyph';
import { GregorioNoteElement } from '../../gregorio-chant/structures/GregorioNoteElement';
import {
  SHAPE, adjusted_queuetype_of, compute_glyph_name,
  gtex_alignment, gtex_glyph_liquescentia, queuetype, queuetype_of
} from './determine_glyph';


export function determine_note_glyph_name(
  note: GregorioNoteElement,
  glyphs: GregorioGlyph[], glyph_index: number): string {
  let name = '';
  let type = gtex_alignment.AT_ONE_NOTE;

  switch (note.shape) {
    case GregorioShape.PUNCTUM_INCLINATUM_ASCENDENS:
      type = gtex_alignment.AT_PUNCTUM_INCLINATUM;
      return SHAPE[SHAPE.AscendensPunctumInclinatum];
    case GregorioShape.PUNCTUM_INCLINATUM_STANS:
      type = gtex_alignment.AT_PUNCTUM_INCLINATUM;
      return SHAPE[SHAPE.StansPunctumInclinatum];
    case GregorioShape.PUNCTUM_INCLINATUM_DESCENDENS:
      type = gtex_alignment.AT_PUNCTUM_INCLINATUM;
      return SHAPE[SHAPE.DescendensPunctumInclinatum];
    case GregorioShape.PUNCTUM_INCLINATUM_DEMINUTUS:
      return SHAPE[SHAPE.PunctumInclinatumDeminutus];
    case GregorioShape.PUNCTUM_INCLINATUM_AUCTUS:
      return SHAPE[SHAPE.PunctumInclinatumAuctus];
    case GregorioShape.PUNCTUM:
      return compute_glyph_name(glyphs, glyph_index, SHAPE.Punctum, gtex_glyph_liquescentia.FUSIBLE_INITIO, true);
    case GregorioShape.PUNCTUM_AUCTUS_ASCENDENS:
      return SHAPE[SHAPE.PunctumAscendens];
    case GregorioShape.PUNCTUM_AUCTUS_DESCENDENS:
      return SHAPE[SHAPE.PunctumDescendens];
    case GregorioShape.PUNCTUM_DEMINUTUS:
      return SHAPE[SHAPE.PunctumDeminutus];
    case GregorioShape.LINEA:
      return SHAPE[SHAPE.Linea];
    case GregorioShape.LINEA_PUNCTUM:
      return SHAPE[SHAPE.LineaPunctum];
    case GregorioShape.VIRGA:
      switch (queuetype_of(note)) {
        case queuetype.Q_ON_SPACE_ABOVE_BOTTOM_LINE:
          return SHAPE[SHAPE.Virga];
        case queuetype.Q_ON_SPACE_BELOW_BOTTOM_LINE:
        case queuetype.Q_ON_BOTTOM_LINE:
          return SHAPE[SHAPE.VirgaOpenqueue];
        case queuetype.Q_ON_LINE_ABOVE_BOTTOM_LINE:
          return SHAPE[SHAPE.VirgaLongqueue];
      } /* all cases return, so this line is not hit; LCOV_EXCL_LINE */
      /* LCOV_EXCL_START */
      // gregorio_fail2(determine_note_glyph_name, "unknown queuetype: %d",
      //   queuetype_of(note));
      return '';
    /* LCOV_EXCL_STOP */
    case GregorioShape.VIRGA_REVERSA:
      switch (note.liquescentia) {
        case GregorioLiquescentia.AUCTUS_ASCENDENS:
          switch (queuetype_of(note)) {
            case queuetype.Q_ON_SPACE_BELOW_BOTTOM_LINE:
            case queuetype.Q_ON_SPACE_ABOVE_BOTTOM_LINE:
              name = SHAPE[SHAPE.VirgaReversaAscendens];
              break;
            case queuetype.Q_ON_BOTTOM_LINE:
              name = SHAPE[SHAPE.VirgaReversaOpenqueueAscendens];
              break;
            case queuetype.Q_ON_LINE_ABOVE_BOTTOM_LINE:
              name = SHAPE[SHAPE.VirgaReversaLongqueueAscendens];
              break;
          }
          if (note.pitch - LOWEST_PITCH == 3) {
            /* if we're on the 'd' line, the queue could be long or short */
            // gregorio_snprintf(buf, sizeof buf,
            //   "VirgaReversaAscendensOnDLine{%s}", code_point(name,
            //     glyph -> u.notes.is_cavum, cpbuf, sizeof cpbuf));
            // return buf;
          }
          return name;
        case GregorioLiquescentia.AUCTUS_DESCENDENS:
          switch (queuetype_of(note)) {
            case queuetype.Q_ON_SPACE_BELOW_BOTTOM_LINE:
            case queuetype.Q_ON_SPACE_ABOVE_BOTTOM_LINE:
              return SHAPE[SHAPE.VirgaReversaDescendens];
            case queuetype.Q_ON_BOTTOM_LINE:
              return SHAPE[SHAPE.VirgaReversaOpenqueueDescendens];
            case queuetype.Q_ON_LINE_ABOVE_BOTTOM_LINE:
              return SHAPE[SHAPE.VirgaReversaLongqueueDescendens];
          } /* all cases return, so this line is not hit; LCOV_EXCL_LINE */
          /* LCOV_EXCL_START */
          // gregorio_fail2(determine_note_glyph_name, "unknown queuetype: %d",
          //   queuetype_of(note));
          return '';
        /* LCOV_EXCL_STOP */
        default:
          return fusible_queued_shape(note, glyphs, glyph_index, SHAPE.VirgaReversa,
            SHAPE.VirgaReversaLongqueue, SHAPE.VirgaReversaOpenqueue);
      }
    case GregorioShape.ORISCUS_ASCENDENS:
      type = gtex_alignment.AT_ORISCUS;
      return compute_glyph_name(glyphs, glyph_index, SHAPE.AscendensOriscus, gtex_glyph_liquescentia.NONE, true);
    case GregorioShape.ORISCUS_DESCENDENS:
      type = gtex_alignment.AT_ORISCUS;
      return compute_glyph_name(glyphs, glyph_index, SHAPE.DescendensOriscus, gtex_glyph_liquescentia.NONE, true);
    case GregorioShape.ORISCUS_DEMINUTUS:
      type = gtex_alignment.AT_ORISCUS;
      return SHAPE[SHAPE.OriscusDeminutus];
    case GregorioShape.QUILISMA:
      type = gtex_alignment.AT_QUILISMA;
      return compute_glyph_name(glyphs, glyph_index, SHAPE.Quilisma, gtex_glyph_liquescentia.NONE, true);
    case GregorioShape.ORISCUS_SCAPUS_ASCENDENS:
      return fusible_queued_shape(note, glyphs, glyph_index, SHAPE.AscendensOriscusScapus,
        SHAPE.AscendensOriscusScapusLongqueue,
        SHAPE.AscendensOriscusScapusOpenqueue);
    case GregorioShape.ORISCUS_SCAPUS_DESCENDENS:
      return fusible_queued_shape(note, glyphs, glyph_index, SHAPE.DescendensOriscusScapus,
        SHAPE.DescendensOriscusScapusLongqueue,
        SHAPE.DescendensOriscusScapusOpenqueue);
    case GregorioShape.STROPHA:
      type = gtex_alignment.AT_STROPHA;
      if (!(note.liquescentia &
        (GregorioLiquescentia.AUCTUS_ASCENDENS | GregorioLiquescentia.AUCTUS_DESCENDENS))) {
        return SHAPE[SHAPE.Stropha];
      }
    /* fall through */
    case GregorioShape.STROPHA_AUCTA:
      type = gtex_alignment.AT_STROPHA;
      switch (queuetype_of(note)) {
        case queuetype.Q_ON_SPACE_BELOW_BOTTOM_LINE:
        case queuetype.Q_ON_SPACE_ABOVE_BOTTOM_LINE:
          return SHAPE[SHAPE.StrophaAucta];
        case queuetype.Q_ON_BOTTOM_LINE:
        case queuetype.Q_ON_LINE_ABOVE_BOTTOM_LINE:
          return SHAPE[SHAPE.StrophaAuctaLongtail];
      } /* all cases return, so this line is not hit; LCOV_EXCL_LINE */
      /* LCOV_EXCL_START */
      // gregorio_fail2(determine_note_glyph_name, "unknown queuetype: %d",
      //   queuetype_of(note));
      return '';
    /* LCOV_EXCL_STOP */
    case GregorioShape.FLAT:
      return SHAPE[SHAPE.Flat];
    case GregorioShape.FLAT_PAREN:
      return SHAPE[SHAPE.FlatParen];
    case GregorioShape.SHARP:
      return SHAPE[SHAPE.Sharp];
    case GregorioShape.SHARP_PAREN:
      return SHAPE[SHAPE.SharpParen];
    case GregorioShape.NATURAL:
      return SHAPE[SHAPE.Natural];
    case GregorioShape.NATURAL_PAREN:
      return SHAPE[SHAPE.NaturalParen];
    default:
      /* not reachable unless there's a programming error */
      /* LCOV_EXCL_START */
      // gregorio_fail2(determine_note_glyph_name,
      //   "called with unknown shape: %s",
      //   gregorio_shape_to_string(note -> u.note.shape));
      return '';
    /* LCOV_EXCL_STOP */
  }
}

function fusible_queued_shape(note: GregorioNoteElement, glyphs: GregorioGlyph[], glyph_index: number,
  base_shape: SHAPE, longqueue_shape: SHAPE, openqueue_shape: SHAPE): string {
  let name: SHAPE;
  const glyph: GregorioGlyph = glyphs[glyph_index];
  if (glyph.notes.fuse_to_next_glyph < 0) {
    /* queue size depends on the following note if fused down */
    const ambitus_one = (glyph.notes.fuse_to_next_glyph == -1);
    switch (adjusted_queuetype_of(note, note, glyph.notes.fuse_to_next_glyph)) {
      case queuetype.Q_ON_SPACE_BELOW_BOTTOM_LINE:
        if (ambitus_one) {
          name = openqueue_shape;
          break;
        }
      /* else fall through */
      case queuetype.Q_ON_SPACE_ABOVE_BOTTOM_LINE:
        /* at ambitus one, long and short are swapped becuase the queue where
         * the second note is on a space is longer than on a line */
        name = ambitus_one ? longqueue_shape : base_shape;
        break;
      case queuetype.Q_ON_BOTTOM_LINE:
        if (ambitus_one) {
          name = openqueue_shape;
          break;
        }
      /* else fall through */
      case queuetype.Q_ON_LINE_ABOVE_BOTTOM_LINE:
        /* at ambitus one, long and short are swapped becuase the queue where
         * the second note is on a line is shorter than on a space */
        name = ambitus_one ? base_shape : longqueue_shape;
        break;
    }
  } else if (glyph.notes.fuse_to_next_glyph) {
    /* TODO (5.0?) handle queue size on upwards fusion */
    switch (queuetype_of(note)) {
      case queuetype.Q_ON_SPACE_BELOW_BOTTOM_LINE:
      case queuetype.Q_ON_SPACE_ABOVE_BOTTOM_LINE:
      case queuetype.Q_ON_BOTTOM_LINE:
        name = base_shape;
        break;
      case queuetype.Q_ON_LINE_ABOVE_BOTTOM_LINE:
        name = longqueue_shape;
        break;
    }
  } else {
    switch (queuetype_of(note)) {
      case queuetype.Q_ON_SPACE_ABOVE_BOTTOM_LINE:
        name = base_shape;
        break;
      case queuetype.Q_ON_SPACE_BELOW_BOTTOM_LINE:
      case queuetype.Q_ON_BOTTOM_LINE:
        name = openqueue_shape;
        break;
      case queuetype.Q_ON_LINE_ABOVE_BOTTOM_LINE:
        name = longqueue_shape;
        break;
    }
  }

  return compute_glyph_name(glyphs, glyph_index, name, gtex_glyph_liquescentia.NONE, true);
}
